import * as React from 'react';

import { VisuallyHidden } from '@coursera/cds-core';

type AddAnnoucement = (message: string) => void;
interface A11yAnnouncerProviderContext {
  /** Write a message that only screen readers will see */
  addAnnouncement: AddAnnoucement;
}

const A11yAnnouncerContext = React.createContext<A11yAnnouncerProviderContext>({
  addAnnouncement: () => undefined,
});

const ANNOUNCEMENT_TEXT_TIME_TO_LIVE = 500;

/**
 * Lives at the top of an application, providing a location to broadcast live updates to a screen reader-using user
 */
export const A11yAnnouncerProvider: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  const [message, setMessage] = React.useState('');
  const [timeoutVar, setTimeoutVar] = React.useState<number>();

  const addAnnouncement = React.useCallback<AddAnnoucement>(
    (newAnnouncement) => {
      clearTimeout(timeoutVar);
      setMessage(newAnnouncement);
      const timeout = window.setTimeout(() => {
        setMessage('');
      }, ANNOUNCEMENT_TEXT_TIME_TO_LIVE);
      setTimeoutVar(timeout);
    },
    [timeoutVar]
  );

  return (
    <A11yAnnouncerContext.Provider
      value={{
        addAnnouncement,
      }}
    >
      <VisuallyHidden role="status">{message}</VisuallyHidden>
      {children}
    </A11yAnnouncerContext.Provider>
  );
};

export const useA11yAnnouncer = () => React.useContext(A11yAnnouncerContext);
